package `fun`.adaptive.resource.graphics

object Graphics